import {User} from '@auth/models/user.model'
import {createAction, props} from '@ngrx/store'

export const setAuthUser = createAction(
  '[Auth] Set Auth User',
  props<{ user: User }>()
)

export const clearAuthUser = createAction('[Auth] Clear Auth User')
